import { render, staticRenderFns } from "./SyncHistoriesList.vue?vue&type=template&id=792d13fb&"
import script from "./SyncHistoriesList.vue?vue&type=script&lang=ts&"
export * from "./SyncHistoriesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports